/**
 * Loading Spinner Component - Reusable loading animation with fiddler logo
 * 
 * Author: Markus van Kempen - markus.van.kempen@gmail.com
 * Last Updated: November 2025
 * Version: 1.0.0
 */

import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...', size = 'large', subtitle }) => {
  return (
    <div className="loading-spinner-container">
      <div className={`loading-spinner-content ${size}`}>
        <div className="loading-spinner-image-wrapper">
          <img 
            src="/waitlogo.png" 
            alt="Loading" 
            className="loading-spinner-image"
          />
        </div>
        {message && <p className="loading-spinner-message">{message}</p>}
        {subtitle && <p className="loading-spinner-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;

